import { render } from "./Profile.vue?vue&type=template&id=7346ce04&lang=pug"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=7346ce04&lang=css"
script.render = render

export default script